import { render, staticRenderFns } from "./dzJSON.vue?vue&type=template&id=310f87d4&scoped=true&"
import script from "./dzJSON.vue?vue&type=script&lang=js&"
export * from "./dzJSON.vue?vue&type=script&lang=js&"
import style0 from "./dzJSON.vue?vue&type=style&index=0&id=310f87d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310f87d4",
  null
  
)

export default component.exports